export const getUniqueCardKey = ({ url, cardId }: { url: string; cardId: string }) => `${cardId}:${url}`;
